"use client";

import React from "react";
import { VeBox, VeTypography } from "@packages/ui/mui";
import { useNetwork } from "@providers/NetworkProvider";

const OfflineIndicator: React.FC = () => {
  const { isOffline } = useNetwork();

  if (!isOffline) return null;

  return (
   <VeBox
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#ff9800',
        color: 'white',
        padding: '8px 16px',
        textAlign: 'center',
        zIndex: 9999,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <VeTypography variant="label3StrongMain">
        You are currently offline. Some features may not work properly.
      </VeTypography>
    </VeBox>
  );
};

export default OfflineIndicator;